import { SxProps, Theme } from '@mui/material';

export const getTaskListStyles = (isDraggingOver: boolean): SxProps<Theme> => ({
     display: 'flex',
     flexWrap: 'wrap',
     gap: 1,
     mt: 1,
     backgroundColor: isDraggingOver ? '#e3f2fd' : 'transparent',
     borderRadius: 1,
     padding: isDraggingOver ? 1 : 0,
     minHeight: 40,
     transition: 'all 0.2s ease',
     border: isDraggingOver ? '2px dashed #2196f3' : 'none',
});

export const getDraggableItemStyles = (isDragging: boolean): SxProps<Theme> => ({
     display: 'flex',
     alignItems: 'center',
     transform: isDragging ? 'rotate(5deg) scale(1.05)' : 'none',
     transition: 'all 0.2s ease',
     zIndex: isDragging ? 1000 : 'auto',
     boxShadow: isDragging ? '0 8px 16px rgba(0,0,0,0.2)' : 'none',
     cursor: isDragging ? 'grabbing' : 'grab',
}); 